document.addEventListener('DOMContentLoaded', function () {
  const blockContainers = document.querySelectorAll('.archive-posts');

  blockContainers.forEach((blockContainer) => {
    const postContainer = blockContainer.querySelector(
      '.archive-posts__posts-wrapper'
    );
    const loadMoreButton = blockContainer.querySelector(
      '.archive-posts__load-more'
    );

    if (!loadMoreButton || !postContainer) return;

    let currentPage = parseInt(loadMoreButton.dataset.page, 10);
    const perPage = parseInt(loadMoreButton.dataset.perPage, 10);
    const totalPages = parseInt(loadMoreButton.dataset.totalPages, 10);
    let loading = false;

    if (currentPage >= totalPages) {
      loadMoreButton.style.display = 'none';
    }

    function fetchPosts() {
      if (loading || currentPage >= totalPages) return;

      loading = true;
      const originalButtonText = loadMoreButton.innerText;
      loadMoreButton.innerText = 'Loading...';

      const offset = currentPage * perPage;

      const urlParams = new URLSearchParams(window.location.search);
      const pageType = urlParams.has('s')
        ? 'search'
        : document.body.classList.contains('category')
        ? 'category'
        : 'index';

      let baseUrl = `/wp-json/wp/v2/posts?_fields=id,title,link,date,excerpt,featured_media&orderby=date&order=desc`;

      if (pageType === 'search') {
        baseUrl += `&search=${urlParams.get('s')}`;
      } else if (pageType === 'category') {
        const categoryId = document.querySelector('.category')?.dataset.id;
        if (categoryId) {
          baseUrl += `&categories=${categoryId}`;
        }
      }

      const url = `${baseUrl}&per_page=${perPage}&offset=${offset}`;

      fetch(url)
        .then((response) => response.json())
        .then((posts) => {
          posts.forEach((post) => renderPost(post));
          currentPage++;
          loadMoreButton.dataset.page = currentPage;

          if (currentPage >= totalPages) {
            loadMoreButton.style.display = 'none';
          } else {
            loadMoreButton.innerText = originalButtonText;
          }

          loading = false;
        })
        .catch((error) => {
          console.error('Error fetching posts:', error);
          loadMoreButton.innerText = originalButtonText;
          loading = false;
        });
    }

    function renderPost(post) {
      const postClasses =
        postContainer?.closest('[data-post-classes]')?.dataset.postClasses ||
        '';

      const postElement = document.createElement('div');
      postElement.className = `flex flex-wrap w-full gap-[2rem] items-center ${postClasses}`;

      const postDate = new Date(post.date).toLocaleDateString();
      const excerptText = (() => {
        const div = document.createElement('div');
        div.innerHTML = post.excerpt?.rendered || '';
        const text = div.textContent || '';
        return text.length > 140 ? text.slice(0, 140) + '...' : text;
      })();

      let html = '';

      if (post.featured_media) {
        html += `
          <a href="${post.link}" class="w-full lg:w-[35%] h-[240px] relative block shrink-0 overflow-hidden rounded-[25px]">
            <img src="" alt="${post.title.rendered}" class="absolute top-0 left-0 w-full h-full object-cover" data-featured-media="${post.featured_media}" />
          </a>`;
      }

      html += `
        <div class="flex-1">
          <p class="text-[0.8rem] text-gray-500 !m-[0]">${postDate}</p>
          <h3 class="text-[2rem]/[1.25] font-semibold leading-snug !m-[0] !mt-[0.125rem]">
            <a href="${post.link}" class="!text-[#212b36]">${post.title.rendered}</a>
          </h3>
          <p class="text-[0.95rem] leading-relaxed">
            ${excerptText} <a href="${post.link}" class="text-blue-600 hover:underline">Read More</a>
          </p>
        </div>
      `;

      postElement.innerHTML = html;
      postContainer.appendChild(postElement);

      const img = postElement.querySelector('img[data-featured-media]');
      if (img) {
        const mediaId = img.getAttribute('data-featured-media');
        fetch(`/wp-json/wp/v2/media/${mediaId}`)
          .then((res) => res.json())
          .then((mediaData) => {
            if (mediaData.source_url) {
              img.src = mediaData.source_url;
            }
          })
          .catch((err) => {
            console.error('Failed to load media', err);
          });
      }
    }

    loadMoreButton.addEventListener('click', fetchPosts);
  });
});
